module.exports = __webpack_public_path__ + "img/1569626717.2cd7252b.jpg";